/** @type {import('../help-index.js').HelpSidebarItem} */
export const LAB_SAL_PAYMENTS_ITEM = {
  id: 'payments_sidebar',
  screenId: 'lab-sal-payments',
  label: 'Pagos',
  description: 'Saldos pendientes y comprobantes pagados por salario.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Consultás cuánto falta pagar de cada salario en un período y ves los comprobantes de pago ya registrados. No registrás pagos acá: eso se hace en Finanzas → Pagos.',
      },
      {
        title: 'Paso 1 — Filtrar',
        fields: [
          { label: 'Empleado', description: 'Buscador opcional por nombre.' },
          { label: 'Periodo', description: 'Obligatorio. Al cargar se elige el primero de la lista si hay períodos habilitados.' },
          { label: 'Nº liq.', description: 'Opcional. Filtra por número de liquidación.' },
          { label: 'Periodos habilitados', description: 'Define qué períodos aparecen en el selector.' },
        ],
        paragraphs: [
          'Sin período seleccionado verás un aviso: «Seleccione un periodo para ver los pagos pendientes».',
        ],
      },
      {
        title: 'Paso 2 — Saldos pendientes',
        bullets: [
          'Columnas: CUIL, Nombre, Nº liq., Moneda, Salario (importe acordado), Pagado, Saldo pendiente.',
          'Tocá una fila para ver el detalle de pagos de ese salario.',
        ],
      },
      {
        title: 'Paso 3 — Pagos del salario',
        intro: 'En la ventana que se abre:',
        bullets: [
          'Lista de comprobantes ya imputados: fecha, tipo, punto de venta - número, importe.',
          'Tocá un comprobante para ver el detalle completo del pago.',
          'Si no hay pagos, aparece «No hay pagos registrados para este salario».',
        ],
      },
      {
        title: 'Cómo registrar un pago nuevo',
        paragraphs: [
          'Andá a Finanzas → Pagos, creá un comprobante de pago e imputá a destino «Salario»: elegí empleado y el salario pendiente. Al volver acá verás el importe en Pagado y el saldo actualizado.',
        ],
      },
    ],
  },
}
